import React from 'react';
import { useRef } from 'react';
import { Button, withStyles } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import translate from '../../locales';
import { connect } from 'react-redux';
import { styleWithCommonClasses } from '../../_constants/emparkConstants';
import { useState } from 'react';
import { RateSwitchTable } from '../Tables/RateSwitchTable';


const __t = translate;

const styles = styleWithCommonClasses({
  buttonCancel: {
    '& span': {
      color: '#7b7c7d'
    }
  },
  error: {
    marginBottom: 10,
    textAlign: 'center',
    color: 'red',
  },
  tableContainer: {
    maxHeight: '40vh',
    overflowY: 'auto',
  }
})

const SwitchRateTableDialog = props => {
  const { classes } = props;

  const [error, setError] = useState(null);

  const tableSubmitRef = useRef(null);

  return (
    <Dialog
      fullWidth
      maxWidth="md"
      open={props.open || false}
      onClose={props.onCancel}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{__t('rates')}</DialogTitle>
      <DialogContent>
        {error && <div className={classes.error}>{error}</div>}

        <div className={classes.tableContainer}>
          <RateSwitchTable
            ref={tableSubmitRef}
            allRates={props.allRates}
            rates={props.rates}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button className={classes.buttonCancel} variant="outlined" color="primary" onClick={props.onCancel}>
          {__t('cancel')}
        </Button>
        <Button variant="outlined" color='primary' onClick={() => {
          const values = tableSubmitRef.current.getSelectedRates();

          // if (values.length === 0) {
          //   setError(__t('empty_selection'));
          //   return;
          // }

          if (values.filter(v => v.productTypeCode === 'ROT').length > 1) {
            setError(__t('error_only_one_rot_allowed'));
            return;
          }

          props.onSubmit(values);
        }}
        >
          {__t('accept')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

function mapStateToProps(state) {
  return {

  }
}


function mapDispatchToProps(dispatch) {
  return {

  }
}

SwitchRateTableDialog.propTypes = {
  open: PropTypes.bool,
  allRates: PropTypes.array,
  rates: PropTypes.array,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(SwitchRateTableDialog));